import { makeAutoObservable } from "mobx";

class PhotobookPageCountStore {
  selectedPageCount = {
    pageId: 0,
    numberOfPages: 0,
    price: 0,
  };

  constructor() {
    makeAutoObservable(this);
  }

  setChoosedCount(pageId: number, numberOfPages: number, price: number) {
    this.selectedPageCount = { pageId, numberOfPages, price };

    console.log(this.selectedPageCount);
  }

  get getChoosedCount() {
    return this.selectedPageCount;
  }
}

const photobookPageCountStore = new PhotobookPageCountStore();
export default photobookPageCountStore;
